import { useContext, useRef, useState } from 'react'
import { useLanguage } from '../../../../../LanguageProvider';
import { GeneralContext } from '../../../../../GeneralProvider';
import { CgCloseO } from 'react-icons/cg';
import { GrAttachment } from 'react-icons/gr';
import { IoDocumentTextOutline } from 'react-icons/io5';
import AddModalInputField from '../../../../../components/AddModalInputField/AddModalInputField';
import { TbStack2 } from 'react-icons/tb';

export default function SocialHiveSettingsUpdate({ selectedChannel }) {
  const { getTranslation } = useLanguage();
  const { handleUpdateChannel } = useContext(GeneralContext);

  // Text fields / privacy
  const [channelName, setChannelName] = useState(selectedChannel.title);
  const [description, setDescription] = useState(selectedChannel.description);
  const [isPrivate, setIsPrivate] = useState(selectedChannel.isPublic === "1" ? false : true);

  // LOGO state
  const [existingLogo, setExistingLogo] = useState(selectedChannel.logo);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef();

  // BANNER state
  const [existingTopBanner, setExistingTopBanner] = useState(selectedChannel.topBanner);
  const [selectedBannerFiles, setSelectedBannerFiles] = useState([]);
  const bannerInputRef = useRef();

  const toBase64Payload = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        const extension = file.name.split('.').pop();
        const title = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
        resolve({ file: base64String, extension, title });
      };
      reader.readAsDataURL(file);
    });

  // LOGO change
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const payload = await toBase64Payload(files[0]);
    setSelectedFiles([payload]); // tek dosya
    setExistingLogo(null);
  };

  // BANNER change
  const handleBannerChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const payload = await toBase64Payload(files[0]);
    setSelectedBannerFiles([payload]); // tek dosya
    setExistingTopBanner(null);
  };

  const removeExistingLogo = () => setExistingLogo(null);
  const removeExistingTopBanner = () => setExistingTopBanner(null);

  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const removeBannerFile = (index) => {
    setSelectedBannerFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const onComplete = () => {
    // logo
    let logoToSend;
    if (selectedFiles.length > 0) {
      logoToSend = selectedFiles[0];
    } else if (selectedChannel.logo && existingLogo === null) {
      // kullanıcı mevcut logoyu kaldırdı
      logoToSend = {};
    }

    // topBanner
    let topBannerToSend;
    if (selectedBannerFiles.length > 0) {
      topBannerToSend = selectedBannerFiles[0];
    } else if (selectedChannel.topBanner && existingTopBanner === null) {
      // kullanıcı mevcut banner'ı kaldırdı
      topBannerToSend = {};
    }

    // Not: !isPrivate -> isPublic
    handleUpdateChannel(
      selectedChannel.channelID,
      channelName,
      description,
      !isPrivate,
      logoToSend,
      topBannerToSend // <-- logoToSend'ten sonra gönderildi
    );
  };

  return (
    <div className="sh-settings-main">
      <div className="sh-settings-content">
        <span
          className="add-channel-modal-title"
          style={{
            alignItems: 'center',
            gap: '15px',
            display: 'flex',
            flexDirection: 'row',
            fontWeight: '500',
            fontSize: '14px',
          }}
        >
          {getTranslation('private')}
          <input
            type="checkbox"
            checked={isPrivate}
            onChange={() => setIsPrivate(!isPrivate)}
          />
        </span>

        <AddModalInputField
          icon={<TbStack2 size={22} style={{ width: '25px' }} />}
          placeholder={getTranslation('channelName') + '*'}
          value={channelName}
          onChange={(e) => setChannelName(e.target.value)}
          type={'text'}
        />

        <div className="add-task-modal-content" style={{ marginTop: '15px' }}>
          <IoDocumentTextOutline
            size={20}
            style={{
              width: '25px',
              alignSelf: 'flex-start',
              marginTop: '10px',
            }}
          />
          <textarea
            className="add-task-modal-textarea"
            placeholder={getTranslation('description')}
            value={description}
            rows={6}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>

        {/* LOGO & BANNER yan yana */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16,
            alignItems: 'start',
            marginTop: 15,
          }}
        >
          {/* LOGO BLOĞU */}
          <div
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '6px',
              display: 'flex',
            }}
          >
            <span
              style={{
                width: '100%',
                flexDirection: 'row',
                alignItems: 'center',
                display: 'flex',
                gap: '5px',
              }}
            >
              <span className="add-channel-modal-attachments-icon">
                <GrAttachment />
              </span>
              <span className="add-channel-modal-attachments">
                {getTranslation('uploadChannelLogo')}
              </span>
            </span>

            <div className="add-channel-modal-select-file-holder">
              <button
                className="action-button"
                onClick={() => fileInputRef.current.click()}
              >
                {getTranslation('selectFile')}
              </button>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.gif,.webp"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </div>

            {selectedFiles.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: '8px',
                  padding: '8px 0',
                  width: '100%',
                }}
              >
                {selectedFiles.map((file, index) => (
                  <div
                    className="add-channel-modal-added-attachment-chip"
                    key={`logo-${index}`}
                  >
                    <span className="add-channel-modal-added-attachment-chip-title">
                      {file.title}
                    </span>
                    <CgCloseO
                      onClick={() => removeFile(index)}
                      style={{
                        cursor: 'var(--pointer)',
                        minWidth: '14px',
                        minHeight: '14px',
                        width: '14px',
                        height: '14px',
                      }}
                    />
                  </div>
                ))}
              </div>
            )}

            {existingLogo && !selectedFiles.length && (
              <div style={{ margin: '8px 0', width: '80px', position: 'relative' }}>
                <img
                  src={existingLogo}
                  alt="Mevcut Logo"
                  style={{ maxHeight: 80, maxWidth: 80, borderRadius: 4 }}
                />
                <CgCloseO
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '50px',
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    cursor: 'var(--pointer)',
                  }}
                  onClick={removeExistingLogo}
                  size={14}
                />
              </div>
            )}
          </div>

          {/* BANNER BLOĞU */}
          <div
            style={{
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '6px',
              display: 'flex',
            }}
          >
            <span
              style={{
                width: '100%',
                flexDirection: 'row',
                alignItems: 'center',
                display: 'flex',
                gap: '5px',
              }}
            >
              <span className="add-channel-modal-attachments-icon">
                <GrAttachment />
              </span>
              <span className="add-channel-modal-attachments">
                {getTranslation('uploadChannelBanner') || 'Banner Yükle'}
              </span>
            </span>

            <div className="add-channel-modal-select-file-holder">
              <button
                className="action-button"
                onClick={() => bannerInputRef.current.click()}
              >
                {getTranslation('selectFile')}
              </button>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.gif,.webp"
                ref={bannerInputRef}
                style={{ display: 'none' }}
                onChange={handleBannerChange}
              />
            </div>

            {selectedBannerFiles.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: '8px',
                  padding: '8px 0',
                  width: '100%',
                }}
              >
                {selectedBannerFiles.map((file, index) => (
                  <div
                    className="add-channel-modal-added-attachment-chip"
                    key={`banner-${index}`}
                  >
                    <span className="add-channel-modal-added-attachment-chip-title">
                      {file.title}
                    </span>
                    <CgCloseO
                      onClick={() => removeBannerFile(index)}
                      style={{
                        cursor: 'var(--pointer)',
                        minWidth: '14px',
                        minHeight: '14px',
                        width: '14px',
                        height: '14px',
                      }}
                    />
                  </div>
                ))}
              </div>
            )}

            {existingTopBanner && !selectedBannerFiles.length && (
              <div
                style={{
                  margin: '8px 0',
                  width: '100%',
                  maxWidth: 320,
                  position: 'relative',
                }}
              >
                <img
                  src={existingTopBanner}
                  alt="Mevcut Banner"
                  style={{
                    width: '100%',
                    maxHeight: 120,
                    objectFit: 'cover',
                    borderRadius: 6,
                  }}
                />
                <CgCloseO
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '50px',
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    cursor: 'var(--pointer)',
                  }}
                  onClick={removeExistingTopBanner}
                  size={14}
                />
              </div>
            )}
          </div>
        </div>

        <div className="add-channel-modal-actions">
          <button onClick={onComplete} className="add-channel-modal-button create">
            {getTranslation('update')}
          </button>
        </div>
      </div>
    </div>
  );
}